import {combineReducers} from "redux";

import {reduceResponse} from "@pg-mono/request-state";

import type {IArticleListArticle} from "../../../article/actions/fetch_article_list";
import type {IRegionReportPrice} from "../../../region/types/IRegionReportPrice";
import {fetchDistrictReportRegionTypes} from "../actions/fetch_district_report_region";
import {fetchPriceReportRegionTypes} from "../actions/fetch_price_report_region";
import {fetchPricesAddressTypes} from "../actions/fetch_prices_address";
import {fetchPricesAddressRoomsTypes} from "../actions/fetch_prices_address_rcn_data";
import {fetchPricesArticleListTypes} from "../actions/fetch_prices_article_list";
import {fetchPricesAvailableDateTypes} from "../actions/fetch_prices_available_date";
import {fetchReportPriceAveragePricesTypes} from "../actions/fetch_report_price_average_prices";
import {fetchTransactionPricesTypes} from "../actions/fetch_transaction_prices";
import {fetchReportPriceAllCitiesPrices} from "../api/fetch_all_cities_prices";
import {fetchReportPriceAllCitiesPricesHistoryTypes} from "../api/fetch_all_cities_prices_history";
import {fetchReportPriceAllCitiesPricesSOld} from "../api/fetch_all_cities_prices_old";
import type {RoomsFilter} from "../constants/rcn_rooms_filter";
import type {IPriceReportAveragePrices} from "../types/IPriceReportAveragePrices";
import type {IPricesAddress} from "../types/IPricesAddress";
import type {IPricesAvailableDate} from "../types/IPricesAvailableDate";
import type {ITransactionPrice} from "../types/ITransactionPrice";

export interface IPriceReportStore {
    pricesAvailableDate: IPricesAvailableDate | null;
    region: IRegionReportPrice | null;
    district: IRegionReportPrice | null;
    address: IPricesAddress | null;
    addressRooms: RoomsFilter[];
    prices: IPriceReportAveragePrices[] | null;
    allCitiesData: IPriceReportAveragePrices[] | null;
    allCitiesDataOld: IPriceReportAveragePrices[] | null;
    allCitiesDataHistory: IPriceReportAveragePrices[] | null;
    transactionPrices: ITransactionPrice[];
    articles: IArticleListArticle[];
}

export const priceReportReducer = combineReducers({
    pricesAvailableDate: reduceResponse<IPricesAvailableDate>(fetchPricesAvailableDateTypes, null),
    region: reduceResponse<IRegionReportPrice>(fetchPriceReportRegionTypes),
    district: reduceResponse<IRegionReportPrice | null>(fetchDistrictReportRegionTypes, null),
    address: reduceResponse<IPricesAddress>(fetchPricesAddressTypes),
    addressRooms: reduceResponse<RoomsFilter[]>(fetchPricesAddressRoomsTypes, []),
    prices: reduceResponse<IPriceReportAveragePrices[]>(fetchReportPriceAveragePricesTypes),
    allCitiesData: reduceResponse<IPriceReportAveragePrices[]>(fetchReportPriceAllCitiesPrices),
    allCitiesDataOld: reduceResponse<IPriceReportAveragePrices[]>(fetchReportPriceAllCitiesPricesSOld),
    allCitiesDataHistory: reduceResponse<IPriceReportAveragePrices[]>(fetchReportPriceAllCitiesPricesHistoryTypes),
    transactionPrices: reduceResponse<ITransactionPrice[]>(fetchTransactionPricesTypes, []),
    articles: reduceResponse<IArticleListArticle[]>(fetchPricesArticleListTypes, [])
});
import {combineReducers} from "redux";

import {reduceResponse} from "@pg-mono/request-state";

import type {IArticleListArticle} from "../../../article/actions/fetch_article_list";
import type {IRegionReportPrice} from "../../../region/types/IRegionReportPrice";
import {fetchDistrictReportRegionTypes} from "../actions/fetch_district_report_region";
import {fetchPriceReportRegionTypes} from "../actions/fetch_price_report_region";
import {fetchPricesAddressTypes} from "../actions/fetch_prices_address";
import {fetchPricesAddressRoomsTypes} from "../actions/fetch_prices_address_rcn_data";
import {fetchPricesArticleListTypes} from "../actions/fetch_prices_article_list";
import {fetchPricesAvailableDateTypes} from "../actions/fetch_prices_available_date";
import {fetchReportPriceAveragePricesTypes} from "../actions/fetch_report_price_average_prices";
import {fetchTransactionPricesTypes} from "../actions/fetch_transaction_prices";
import {fetchReportPriceAllCitiesPrices} from "../api/fetch_all_cities_prices";
import {fetchReportPriceAllCitiesPricesHistoryTypes} from "../api/fetch_all_cities_prices_history";
import {fetchReportPriceAllCitiesPricesSOld} from "../api/fetch_all_cities_prices_old";
import type {RoomsFilter} from "../constants/rcn_rooms_filter";
import type {IPriceReportAveragePrices} from "../types/IPriceReportAveragePrices";
import type {IPricesAddress} from "../types/IPricesAddress";
import type {IPricesAvailableDate} from "../types/IPricesAvailableDate";
import type {ITransactionPrice} from "../types/ITransactionPrice";

export interface IPriceReportStore {
    pricesAvailableDate: IPricesAvailableDate | null;
    region: IRegionReportPrice | null;
    district: IRegionReportPrice | null;
    address: IPricesAddress | null;
    addressRooms: RoomsFilter[];
    prices: IPriceReportAveragePrices[] | null;
    allCitiesData: IPriceReportAveragePrices[] | null;
    allCitiesDataOld: IPriceReportAveragePrices[] | null;
    allCitiesDataHistory: IPriceReportAveragePrices[] | null;
    transactionPrices: ITransactionPrice[];
    articles: IArticleListArticle[];
}

export const priceReportReducer = combineReducers({
    pricesAvailableDate: reduceResponse<IPricesAvailableDate>(fetchPricesAvailableDateTypes, null),
    region: reduceResponse<IRegionReportPrice>(fetchPriceReportRegionTypes),
    district: reduceResponse<IRegionReportPrice | null>(fetchDistrictReportRegionTypes, null),
    address: reduceResponse<IPricesAddress>(fetchPricesAddressTypes),
    addressRooms: reduceResponse<RoomsFilter[]>(fetchPricesAddressRoomsTypes, []),
    prices: reduceResponse<IPriceReportAveragePrices[]>(fetchReportPriceAveragePricesTypes),
    allCitiesData: reduceResponse<IPriceReportAveragePrices[]>(fetchReportPriceAllCitiesPrices),
    allCitiesDataOld: reduceResponse<IPriceReportAveragePrices[]>(fetchReportPriceAllCitiesPricesSOld),
    allCitiesDataHistory: reduceResponse<IPriceReportAveragePrices[]>(fetchReportPriceAllCitiesPricesHistoryTypes),
    transactionPrices: reduceResponse<ITransactionPrice[]>(fetchTransactionPricesTypes, []),
    articles: reduceResponse<IArticleListArticle[]>(fetchPricesArticleListTypes, [])
});
